import React, { useState } from 'react';
import {
  Collapse as BPCollapse,
  CollapseProps as ICollapseProps
} from '@blueprintjs/core';
import { Col, Container, Row } from '../../../grid';
import Button from '../../molecules/button';
import { BulkPushMessageAction } from '../action/bulkPM';
import { useMetaData } from '../../../contexts/metadata';

const bulkPMCategories = [
  'danger',
  'warning',
  'success',
  'recent',
  'unresponsive'
];

interface CollapseProps extends ICollapseProps {
  header?: JSX.Element;
  categoryString?: string;
  text?: {
    collapse: string;
    expand: string;
  };
  defaultOpen?: boolean;
  setIsOpen?: (value: boolean) => void;
}

const Collapse: React.FC<CollapseProps> = ({
  children,
  defaultOpen = false,
  header,
  text = {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  categoryString,
  isOpen,
  setIsOpen
}) => {
  const [_isOpen, _setIsOpen] = useState(defaultOpen);
  // Allow the open state to be controlled from the oustide
  const isOpenState = isOpen != null ? isOpen : _isOpen;
  const isPmEnabled = useMetaData().account?.isPushMessageEnabled;
  const setIsOpenState = (value: boolean) => {
    if (setIsOpen != null) {
      setIsOpen(value);
    } else {
      _setIsOpen(value);
    }
  };
  return (
    <Container>
      <Row
        className="cursor-pointer"
        onClick={() => setIsOpenState(!isOpenState)}
        style={{ alignItems: 'center' }}
        tabIndex={0}
      >
        <Col>{header}</Col>
        <Col className="text-right">
          {bulkPMCategories.includes(categoryString) && isPmEnabled ? (
            <BulkPushMessageAction
              header={header.props.children[0]}
              categoryString={categoryString}
            />
          ) : null}
          <Button
            variant="minimal"
            onClick={() => setIsOpenState(!isOpenState)}
          >
            {isOpenState ? text.collapse : text.expand}
          </Button>
        </Col>
      </Row>
      <BPCollapse isOpen={isOpenState}>{children}</BPCollapse>
    </Container>
  );
};

export default Collapse;
